import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../context/BootstrapToast';
import { useConfirm } from '../context/BootstrapConfirm';
import { toast } from 'react-toastify';
//teste
export default function useErrors() {
    const { logout } = useAuth(); // Corrigido: usar logout ao invés de LogOut
    const { addNotification } = useNotification();
    const confirm = useConfirm();
    const navigate = useNavigate();

    const setErrors = errors => {
        if (errors) {
            if (!Boolean(errors)) {
                toast.error('Serviço indisponível');
                return;
            }

            if (!Boolean(errors.response)) {
                toast.error('Sistema sem resposta');
                return;
            }

            const { status } = errors.response;

            if (status === 401) {
                console.log(errors.response.data.error)
                if (errors.response.data.error == 'refresh_token_reject') {
                    navigate('/', { replace: true });
                    logout(); // Corrigido: usar logout
                    toast.error('Faça o login novamente.');
                }

                return;
            }

            if (status === 404) {
                toast.error('Caminho não encontrado');
                return;
            }

            if (errors.response.data) {
                if (Array.isArray(errors.response.data.message)) {
                    errors.response.data.message.forEach(item => {
                        toast.error(item.message);
                    });

                    return;
                }

                if (errors.response.data.message) {
                    toast.error(errors.response.data.message);
                    return;
                }
            }

            if (errors.response.message) {
                toast.error(errors.response.data);
                return;
            }

            toast.error('Servidor indisponível. Já estamos revisando!', 'warning');
            return;
        }
    };

    return { setErrors, confirm, addNotification, toast:toast };
}
